import { render, staticRenderFns } from "./ImageInputsList.vue?vue&type=template&id=57899978&lang=html"
import script from "./ImageInputsList.vue?vue&type=script&lang=js"
export * from "./ImageInputsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports